import Chip from "components/chip/Regacy__Chip";
import React from "react";
import { StyledChipArea } from "./style";
import { DropDownListOptionType } from "types/common/CommonType";

export const ChipArea = ({
  title,
  hasClose = true,
  selectedList,
  onDelete,
  chipSize = "s",
  height = "7.2rem",
}: {
  title?: string;
  hasClose: boolean;
  selectedList: DropDownListOptionType<string>[];
  onDelete: (deleteName: string) => void;
  chipSize?: "s" | "xs";
  height?: string;
}) => {
  return (
    <StyledChipArea $height={height}>
      {title && <p className="label-area">{title}</p>}
      <div className="chip-wrap">
        {selectedList.map((item) => (
          <Chip
            key={item.value}
            label={item.label}
            close={hasClose}
            type="blue"
            size={chipSize}
            deleteChip={onDelete}
            deleteKey={item.label}
          />
        ))}
      </div>
    </StyledChipArea>
  );
};
